import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { UpdateInvoice, update_invoice_status } from "../actions/orders";
import { customerShipmentDoc } from "../actions/shipmentNPayment";
import close from "../assets/cancel_w.svg";

const ShipmentDoc = () => {
  const location = useLocation();
  const params = useParams();
  const dispatch = useDispatch();
  const profoma_doc = useSelector(
    (state) => state.shipNPay.customer_shipment_doc
  );
  const invoice = useSelector((state) => state.orders.invoice_update);

  const history = useHistory();

  useEffect(() => {
    dispatch(
      customerShipmentDoc({
        email: localStorage.getItem("email"),
        delivery_no: location?.state?.delNo ?? params?.id,
      })
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (invoice?.success) {
      toast.success(invoice?.data?.message);
      dispatch({
        type: UpdateInvoice.RESET,
      });
      history.goBack();
    }
    // eslint-disable-next-line
  }, [invoice]);

  return (
    <div className="profoma-doc">
      <div className="profoma-header">
        <div>
          {location.state?.order_no ? (
            <span>Order ID - {location.state?.order_no}</span>
          ) : (
            ""
          )}
          {location.state?.do_number ? (
            <span>DO Number - {location.state?.do_number}</span>
          ) : (
            ""
          )}
          <span>{location.state?.time}</span>
        </div>
        <div className="flex-center">
          {location?.state?.isPending && (
            <button
              className="approve-btn mr2"
              disabled={invoice?.loading}
              onClick={() => {
                dispatch(
                  update_invoice_status({
                    invoice_no: location.state?.delNo,
                  })
                );
              }}
            >
              {invoice?.loading ? "Approving" : "Approve"}
            </button>
          )}
          <img
            src={close}
            alt={"close"}
            width={20}
            onClick={() => history.goBack()}
          />
        </div>
      </div>
      {profoma_doc?.loading ? (
        "Loading..."
      ) : profoma_doc?.data?.pdf_content ? (
        <embed
          src={"data:application/pdf;base64," + profoma_doc?.data?.pdf_content}
        />
      ) : (
        profoma_doc?.data?.message
      )}
    </div>
  );
};

export default ShipmentDoc;
